// app/javascript/controllers/feedbacks_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "smiley",
    "input",
    "feedbackModal",
    "comment",
    "source",
    "issue",
  ];

  initialize() {
    this.handleKeyDown = this.handleKeyDown.bind(this);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.closeFeedbackModal();
    }
  }

  select(event) {
    const selectedRating = event.currentTarget.dataset.rating;

    this.smileyTargets.forEach((el) => {
      el.classList.remove(
        ...Array.from({ length: 5 }, (_, i) => `selected-${i + 1}`)
      );
    });

    event.currentTarget.classList.add(`selected-${selectedRating}`);
    this.inputTarget.value = selectedRating;
  }

  openFeedbackModal() {
    this.feedbackModalTarget.classList.remove("hidden");
  }

  closeFeedbackModal() {
    this.feedbackModalTarget.classList.add("hidden");
  }

  hideFeedbackModal() {
    this.clearForm();
    this.closeFeedbackModal();
  }

  clearForm() {
    this.smileyTargets.forEach((el) => {
      el.classList.remove(
        ...Array.from({ length: 5 }, (_, i) => `selected-${i + 1}`)
      );
    });

    this.inputTarget.value = null;
    this.commentTarget.value = null;

    this.issueTargets.forEach((el) => {
      el.checked = false;
    });
  }

  submitFeedback() {
    const rating = parseInt(this.inputTarget.value, 10);
    const issues = this.issueTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
    const comment =
      this.commentTarget.value === "" ? null : this.commentTarget.value;
    const source = this.sourceTarget.value;

    fetch(`/feedbacks`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          .content,
      },
      body: JSON.stringify({
        feedback: {
          smiley_rating: rating,
          issues: issues,
          comment: comment,
          source_location: source,
        },
      }),
    })
      .then(async (response) => {
        if (response.ok) {
          this.hideFeedbackModal();
          alert("Thank you for your feedback!");
        } else {
          return response.json().then((data) => {
            console.error("Feedback submission failed:", data);
            alert("Something went wrong. Please try again.");
          });
        }
      })
      .catch((error) => {
        console.error("Network error:", error);
        alert("Network error. Please try again.");
      });
  }
}
